var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    group = _require$doc$builders.group,
    concat = _require$doc$builders.concat,
    indent = _require$doc$builders.indent,
    line = _require$doc$builders.line,
    softline = _require$doc$builders.softline;

module.exports = {
  match: function match(op) {
    return op === '**';
  },
  print: function print(node, path, _print, options) {
    return group(indent(concat([path.call(_print, 'left'), options.spacedExp ? ' ' : '', node.operator, options.spacedExp ? line : softline, path.call(_print, 'right')])));
  }
};